import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isIosDevice, isStandaloneDisplayMode, type BeforeInstallPromptEvent } from "../../lib/pwa";
import { AppIcon } from "./AppIcon";

export function InstallAppAction() {
  const { t } = useTranslation();
  const [promptEvent, setPromptEvent] = useState<BeforeInstallPromptEvent | null>(null);
  const [showIosHelp, setShowIosHelp] = useState(false);
  const [installed, setInstalled] = useState(() => isStandaloneDisplayMode());
  const ios = isIosDevice();

  useEffect(() => {
    const onPrompt = (event: Event) => {
      event.preventDefault();
      setPromptEvent(event as BeforeInstallPromptEvent);
    };
    const onInstalled = () => { setInstalled(true); setPromptEvent(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || (!ios && !promptEvent)) return null;

  const install = async () => {
    if (promptEvent) {
      await promptEvent.prompt();
      const choice = await promptEvent.userChoice;
      if (choice.outcome === "accepted") setInstalled(true);
      setPromptEvent(null);
      return;
    }
    setShowIosHelp((value) => !value);
  };

  return <div className="install-app-action">
    <button onClick={() => void install()} type="button"><AppIcon name="plus"/>{t("pwa.install")}</button>
    {showIosHelp && <p role="status">{t("pwa.iosInstructions")}</p>}
  </div>;
}
